import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	const title = node.title;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	// const base64String = await pathToBase64(`/images/custom/flower/theme.png`)
	const background = await getBackground(data?.customTheme)
	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "hbqE_R6pY2",
				"width": 422.4,
				"height": 68.984375,
				"left": 293.7,
				"top": 158.33,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 48.98px;font-family: +mj-ea;\">${title}</span><span style=\"font-size: 48.98px;font-family: +mj-ea;\">ppt</span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "rQSEOGQxPz",
				"width": 194.76449344457689,
				"height": 40.375,
				"left": 407.5177532777115,
				"top": 339.38,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: Arial;\">汇报人：ChatGpt</span></span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "jNmOJ8ZGxY",
				"width": 237.92,
				"height": 40.375,
				"left": 385.94,
				"top": 385.16,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">时间：</span><span style=\"font-size: 18.37px;font-family: Arial;\">xxxx</span><span style=\"font-size: 18.37px;font-family: Arial;\">年</span><span style=\"font-size: 18.37px;font-family: Arial;\">xx</span><span style=\"font-size: 18.37px;font-family: Arial;\">月</span><span style=\"font-size: 18.37px;font-family: Arial;\">xx</span><span style=\"font-size: 18.37px;font-family: Arial;\">日</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			}
		],
		background
	};
}